import React from "react";
import { Stack } from "@mui/material";
import ExperianLogo from "images/experian-business-logo.svg";
import EquifaxLogo from "images/equifax-business-logo.svg";
import TrustedLogo from "./TrustedLogo";

export const BureauLogo = () => {
  return (
    <Stack
      direction="column"
      spacing={2}
      justifyContent="center"
      alignItems="center"
      sx={{
        marginY: "1rem",
      }}
    >
      <TrustedLogo />
      <Stack
        direction="row"
        spacing={2}
        justifyContent="center"
        alignItems="center"
        sx={{
          marginY: "1rem",
        }}
      >
        <img alt="equifax_logo" src={EquifaxLogo} style={{ height: "12.59px", width: "63.57px",  opacity: "50%" }} />
        <img alt="experian_logo" src={ExperianLogo} style={{ height: "23.75px", width: "71.52px",  opacity: "50%" }} />
      </Stack>
    </Stack>
  );
};

export const BureauLogoDesktop = () => {
  return (
    <Stack
      direction="column"
      spacing={2}
      justifyContent="start"
      alignItems="start"
      sx={{
        marginY: "1rem",
      }}
    >
      <TrustedLogo />
      <Stack
        direction="row"
        spacing={2}
        justifyContent="start"
        alignItems="center"
        sx={{
          marginY: "1rem",
        }}
      >
        <img alt="equifax_logo" src={EquifaxLogo} style={{ height: "16.26px", width: "82.12px",  opacity: "80%" }} />
        <img alt="experian_logo" src={ExperianLogo} style={{ height: "30.67px", width: "92.38px",  opacity: "80%" }} />
      </Stack>
    </Stack>
  );
};